// Custom utils for formik where the out of the box utils are not sufficient.

/* The dirty boolean exported by formik doesn't react to dropdown changes.
 * The custom built function "isDirty" overcomes this limitation
 */
export const isDirty = (initialValues: any, values: any) => {
  return JSON.stringify(initialValues) !== JSON.stringify(values);
};
